import {Document} from '@/model/types';
import {createDependencyRegistrer} from '../dependencies';
import {AccessMap, DependencyMap} from '../types';
import {ModelDocument} from '../types/model/document';
import {createConditionFactory} from './condition';

export const mapDocuments = (
  documents: Document[],
  dependencyMap: DependencyMap,
  accessMap: AccessMap,
): ModelDocument[] => {
  return documents.map((document, index) => {
    const dependencyRegistrer = createDependencyRegistrer(dependencyMap, document.type);

    accessMap.set(document.type, {documentIndex: index});

    return {
      type: document.type,
      filename: document.filename,
      conditions: document.conditions.map(condition =>
        createConditionFactory(condition, dependencyRegistrer, 'visibility'),
      ),
      mappers: document.mappers,
      replacements: document.replacements,
    };
  });
};
